import type { Theme } from 'hephaestus/core';

/** TableHeadCell uses outline for column dividers; swap to borders to avoid bleed. */
export const bulkRebalanceTableHeadDividerSx = (theme: Theme) => ({
  '& thead .MuiTableCell-root': {
    outline: 'none',
    borderRight: `1px solid ${theme.color.surface ?? 'transparent'}`,
    borderBottom: `1px solid ${theme.color.outlineVariant ?? 'transparent'}`,
    '&:last-of-type': {
      borderRight: 'none',
    },
  },
});
